const ABOUT_IMG = "https://images.unsplash.com/photo-1578402027442-b0d03cd2c0a6?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80";

import { useLang } from "@/context/LanguageContext";

export default function About() {
  const { t } = useLang();
  return (
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 md:py-24">
      <div className="eyebrow mb-8">{t("about.eyebrow")}</div>
      <h1 className="font-headline text-5xl md:text-6xl lg:text-7xl leading-none tracking-tight text-[#111111] max-w-4xl">
        {t("about.title")}
      </h1>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <div className="eyebrow">{t("about.mission")}</div>
        </div>
        <div className="md:col-span-8">
          <p className="font-body text-lg md:text-xl text-[#111111] leading-relaxed">
            {t("about.missionBody")}
          </p>
        </div>
      </div>

      <hr className="hairline my-16" />

      <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <div className="eyebrow">{t("about.tradition")}</div>
        </div>
        <div className="md:col-span-8">
          <p className="font-body text-lg md:text-xl text-[#111111] leading-relaxed">
            {t("about.traditionBody")}
          </p>
        </div>
      </div>

      <hr className="hairline my-16" />

      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-start">
        <div className="md:col-span-4">
          <div className="eyebrow">{t("about.values")}</div>
        </div>
        <div className="md:col-span-8">
          <p className="font-headline text-3xl md:text-4xl leading-tight">
            {t("about.valuesLine")}
          </p>
        </div>
      </div>

      <div className="mt-16 border border-[#DCDCDC]">
        <img src={ABOUT_IMG} alt="Institute reading room" className="w-full h-[420px] object-cover grayscale" />
      </div>
    </div>
  );
}
